import { Injectable } from '@angular/core'
import { Exemplo } from '../../models/Exemplo'
import { Observable } from 'rxjs'
import { concatenateUrl } from '../../../common/support/api'
import { RestService } from '../../../common/services/rest/Rest.service'
import{Empresa} from "../../../lib/models/Empresa"
const service = {
  name: 'Exemplo',
  url: 'exemplo'
}

@Injectable({
  providedIn: 'root'
})
export class EmpresaService extends RestService<Empresa> {
  private readonly API_URL = concatenateUrl(service.url)

  obterCnpj (cnpj: string): Observable<Empresa> | any {
    return this.get(`http://10.250.250.248:8080/empresasbrasileiras/api/empresas_brasileiras?cnpj=${cnpj}`)
  }
  

  
}

